import { useState } from "react";

import PotWithTg from "shared/assets/pot-with-tg.svg?react";
import { ZkCertType, zkCertTypes } from "shared/config/consts/zk-cert-types";

import { Row } from "./row";
import { SearchInput } from "./search-input";

type Props = {
  onSelect: (type: ZkCertType) => void;
};

export const SelectType = (props: Props) => {
  const { onSelect } = props;

  const [input, setInput] = useState<string>("");

  const filteredTypes = input
    ? zkCertTypes.filter((t) => {
        return t.title.toLowerCase().includes(input.toLowerCase());
      })
    : zkCertTypes;

  return (
    <>
      <PotWithTg className="mt-8.5 shrink-0" />
      <h2 className="mt-5 text-center text-2xl font-semibold whitespace-pre-line">
        {`Select the type of\nCertificate to get`}
      </h2>

      <div className="bg-whiteSmoke mt-7.5 flex w-full flex-col overflow-y-auto rounded-xl py-3">
        <SearchInput
          value={input}
          onChange={(e) => {
            setInput(e.target.value.trim());
          }}
          className="sticky top-0 mb-1 px-3"
        />
        {filteredTypes.map((t) => {
          return (
            <Row
              key={t.title}
              text={t.title}
              image={t.icon}
              onClick={() => {
                onSelect(t.value);
              }}
            />
          );
        })}
      </div>
    </>
  );
};
